<template>
  <div class="page-template add-page">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button type="primary" plain @click="beBack">返回</el-button>
      <el-button @click="refresh" type="primary" plain v-show="formModel.reviewerStatus !==10">刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
    </div>
    <list-operation-form ref="listOperationForm" :formOptions="listFormOptions"></list-operation-form>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
  </div>
</template>
<script>
  //表单单组件
  import listOperation from '@/components/template/listOperation';
  //搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';
  import listOperationNew from "@/components/template/listOperationNew";
  //数据权限
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      listOperationNew,
      listOperation,
      listOperationForm
    },
    data() {
      return {
        listTableData: [],
        goodListSelect: false,
        loading: false,
        title: '',
        listShow: false,
        goodList: [],
        formModel: {
          reviewerStatus: null
        },
        dialogShow: false,
        isSelectSupplier: true,
        isSelectWarehouse: true,
        isClearTableData: true,
        otherParam: {statusList: [10, 20]},
        selectUrl: {url: api.warehouse.warehouseGoods},
        //头部条件
        listFormOptions: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
          },
          labelWidth: '130px',
          columns: [
            {
              prop: 'id',
              hidden: true
            },
            {
              label: '差异单号',
              type: 'input',
              prop: 'orderNo',
              span: 8,
              disabled: true
            },
            {
              label: '调出门店',
              type: 'storeInputDialog',
              prop: 'outerStoreId',
              data: [],
              span: 8,
              disabled: true,
              isHasAll: true,//下拉选择添加‘总部’字段
              url: api.store.store,
              change: this.getOuterWarehouse,
            },
            {
              label: "调出仓库",
              type: "warehouseInputDialog",
              prop: "outerWarehouseId",
              data: [],
              disabled: true,
              span: 8,
            },
            {
              label: '调入门店',
              type: 'storeInputDialog',
              prop: 'enterStoreId',
              data: [],
              span: 8,
              disabled: true,
              isHasAll: true,//下拉选择添加‘总部’字段
              url: api.store.store,
              change: this.getEnterWarehouse,
            },
            {
              label: "调入仓库",
              type: "warehouseInputDialog",
              prop: "enterWarehouseId",
              data: [],
              disabled: true,
              span: 8,
            },
            {
              label: '经手人',
              prop: 'handler',
              type: 'input',
              disabled: false,
              span: 8
            },
            {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              span: 8,
            }]
        },
        // 添加表格字段
        listColumns: {
          height: this.height,
          summaryColumns: ['outerNum', 'enterNum', 'differenceNum', 'differenceAmount'],
          columns: [
            {label: '序号', type: 'index', width: 60, prop: 'idx'},
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '90'
            },
            {
              label: '出库数量',
              prop: 'outerNum',
              align: "center"
            },
            {
              label: '入库数量',
              prop: 'enterNum',
              align: "center"
            },
            {
              label: '差异数量',
              prop: 'differenceNum',
              align: "center"
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              align: "center"
            },
            {
              label: '差异金额',
              prop: 'differenceAmount',
              align: "center"

            },
            {
              label: '备注',
              prop: 'remarks',
              width: '90',
              align: "center"
            },
          ]
        },
        checkIndex: '',
      }
    },
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.title = (this.$route.query.id ? '编辑' : '新增') + document.title;
      if (this.$route.query.id) {
        this.getDetail();
      }
    },
    methods: {
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.delivery.differenceOrder + '?id=' + this.$route.query.id, {})
          .then(data => {
            this.formModel = data.data;
            this.loading = false;
            if (data.code === 200) {
              this.$nextTick(() => {
                //为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                //为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.allocationDifferenceOrderMapList, 0);
                this.currentTableList = this.$refs["listOperation"].getTabelData();
              });
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      refresh() {
        this.$router.go(0);
      },
      //提交数据
      submitAuth() {
        //将商品list的值重新赋值给后端接收的参数
        let tableList = this.$refs['listOperation'].getTabelData();
        //将合计的值重新赋值给后端接收的参数
        let totalParam = this.$refs['listOperation'].getSumData();
        //将表头的值重新赋值给后端接收的参数
        let headParam = this.$refs.listOperationForm.getFormModel();
        headParam.auditStatus = 20;
        let searchParam = {
          ...{allocationDifferenceOrderMapList: tableList}, ...totalParam, ...headParam
        };
        this.$confirm('是否确认审核?', '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          this.handleRequest(this.$axios.fetchPost(api.delivery.differenceOrder + '/audit', searchParam));
        }).catch(() => this.$message({message: '审核取消！', type: 'info'}));
      },
      handleRequest(param) {
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)',
        });
        param.then(data => {
          if (data.code === 200) {
            this.$notify({
              type: "success",
              title: '审核操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '审核成功！', type: 'success'});
            this.$router.push({path: '/delivery/difference'});
          } else {
            this.$notify({
              type: "error",
              title: '审核操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '审核失败！', type: 'error'});
          }
          loading.close()
        })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            loading.close()
          });
      },
      getOuterWarehouse(form) {
        //根据门店获取相应仓库
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.outerStoreId}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'outerWarehouseId')[0].data = data.data;
          }
        })
      },
      getEnterWarehouse(form) {
        //根据门店获取相应仓库
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: form.enterStoreId}).then(data => {
          if (data.code === 200) {
            this.listFormOptions.columns.filter(item => item.prop === 'enterWarehouseId')[0].data = data.data;
          }
        })
      },
    }

  }
</script>





// WEBPACK FOOTER //
// src/page/delivery/DifferenceAdd.vue